import {SteeringCommandInput} from './SteeringCommandInput'
import styles from './StickySteeringCommand.module.css'

type StickySteeringCommandProps = {
  onSubmit: (message: string) => void
  error?: string | null
}

export function StickySteeringCommand({onSubmit, error}: StickySteeringCommandProps) {
  return (
    <div className={styles.stickyContainer}>
      <SteeringCommandInput onSubmit={onSubmit} error={error} />
    </div>
  )
}
